import React from 'react';
import PropTypes from 'prop-types';
import { defaultTemplate } from 'core/hoc';
import { ApplicationEmptyState, BaasicButton } from 'core/components';
import { PreviewLayout, PageFooter } from 'core/layouts';

function ProductHistoryPreviewTemplate({ productHistoryPreviewViewStore }) {
    const {
        rootStore,
        item,
        previousItem,
        loaderStore,
    } = productHistoryPreviewViewStore;

    return (
        item && previousItem &&
        <PreviewLayout store={productHistoryPreviewViewStore} emptyRenderer={<ApplicationEmptyState />} loading={loaderStore.loading}>
            <div className="row">
                <div className="col col-sml-12 col-lrg-8">
                    <div className="card card--form card--primary card--med">
                        <div className="u-mar--bottom--med">
                            <div className="u-flex--space-between">
                                <div className='form__title'>
                                    <h4><b>Details</b></h4>
                                </div>
                                <div className='u-mar--bottom--sml'>
                                    <p><b>Updated on {item.date} by {item.coreUserName}</b></p>
                                </div>
                            </div>
                            <div>
                                <div className="u-separator--preview">
                                    <div className="row">
                                        <div className="col col-sml-12 col-lrg-4"></div>
                                        <div className="col col-sml-12 col-lrg-4">
                                            <div className="form__group__label is-preview">OLD</div>
                                        </div>
                                        <div className="col col-sml-12 col-lrg-4">
                                            <div className="form__group__label is-preview">NEW</div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            {previousItem.itemId != item.itemId &&
                                <div>
                                    <div className="u-separator--preview">
                                        <div className="row">
                                            <div className="col col-sml-12 col-lrg-4">
                                                <div className="form__group__label is-preview">Item Id</div>
                                            </div>
                                            <div className="col col-sml-12 col-lrg-4">
                                                <React.Fragment>{previousItem.itemId}</React.Fragment>
                                            </div>
                                            <div className="col col-sml-12 col-lrg-4">
                                                <React.Fragment>{item.itemId}</React.Fragment>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            }
                            {previousItem.description != item.description &&
                                <div>
                                    <div className="u-separator--preview">
                                        <div className="row">
                                            <div className="col col-sml-12 col-lrg-4">
                                                <div className="form__group__label is-preview">Item Name</div>
                                            </div>
                                            <div className="col col-sml-12 col-lrg-4">
                                                <React.Fragment>{previousItem.description}</React.Fragment>
                                            </div>
                                            <div className="col col-sml-12 col-lrg-4">
                                                <React.Fragment>{item.description}</React.Fragment>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            }
                            {previousItem.alternativeName != item.alternativeName &&
                                <div>
                                    <div className="u-separator--preview">
                                        <div className="row">
                                            <div className="col col-sml-12 col-lrg-4">
                                                <div className="form__group__label is-preview">Alternative Name</div>
                                            </div>
                                            <div className="col col-sml-12 col-lrg-4">
                                                {previousItem.alternativeName}
                                            </div>
                                            <div className="col col-sml-12 col-lrg-4">
                                                {item.alternativeName}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            }
                            {previousItem.itemCategoryId != item.itemCategoryId &&
                                <div>
                                    <div className="u-separator--preview">
                                        <div className="row">
                                            <div className="col col-sml-12 col-lrg-4">
                                                <div className="form__group__label is-preview">Item Category</div>
                                            </div>
                                            <div className="col col-sml-12 col-lrg-4">
                                                {previousItem.itemCategory && previousItem.itemCategory.name}
                                            </div>
                                            <div className="col col-sml-12 col-lrg-4">
                                                {item.itemCategory && item.itemCategory.name}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            }
                            {previousItem.subCategoryId != item.subCategoryId &&
                                <div>
                                    <div className="u-separator--preview">
                                        <div className="row">
                                            <div className="col col-sml-12 col-lrg-4">
                                                <div className="form__group__label is-preview">SubCategory</div>
                                            </div>
                                            <div className="col col-sml-12 col-lrg-4">
                                                {previousItem.subCategory && previousItem.subCategory.name}
                                            </div>
                                            <div className="col col-sml-12 col-lrg-4">
                                                {item.subCategory && item.subCategory.name}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            }
                            {previousItem.procedureCodeId != item.procedureCodeId &&
                                <div>
                                    <div className="u-separator--preview">
                                        <div className="row">
                                            <div className="col col-sml-12 col-lrg-4">
                                                <div className="form__group__label is-preview">Procedure Code</div>
                                            </div>
                                            <div className="col col-sml-12 col-lrg-4">
                                                {previousItem.procedureCode_ && previousItem.procedureCode_.name}
                                            </div>
                                            <div className="col col-sml-12 col-lrg-4">
                                                {item.procedureCode_ && item.procedureCode_.name}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            }
                            {previousItem.unitOfMeasureId != item.unitOfMeasureId &&
                                <div>
                                    <div className="u-separator--preview">
                                        <div className="row">
                                            <div className="col col-sml-12 col-lrg-4">
                                                <div className="form__group__label is-preview">Unit Of Measure</div>
                                            </div>
                                            <div className="col col-sml-12 col-lrg-4">
                                                {previousItem.unitOfMeasure && previousItem.unitOfMeasure.name}
                                            </div>
                                            <div className="col col-sml-12 col-lrg-4">
                                                {item.unitOfMeasure && item.unitOfMeasure.name}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            }
                            {previousItem.units != item.units &&
                                <div>
                                    <div className="u-separator--preview">
                                        <div className="row">
                                            <div className="col col-sml-12 col-lrg-4">
                                                <div className="form__group__label is-preview">MCR Multiplier</div>
                                            </div>
                                            <div className="col col-sml-12 col-lrg-4">
                                                {previousItem.units}
                                            </div>
                                            <div className="col col-sml-12 col-lrg-4">
                                                {item.units}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            }
                            {previousItem.qtyPerCase != item.qtyPerCase &&
                                <div>
                                    <div className="u-separator--preview">
                                        <div className="row">
                                            <div className="col col-sml-12 col-lrg-4">
                                                <div className="form__group__label is-preview">Quantity Per Case</div>
                                            </div>
                                            <div className="col col-sml-12 col-lrg-4">
                                                {previousItem.qtyPerCase}
                                            </div>
                                            <div className="col col-sml-12 col-lrg-4">
                                                {item.qtyPerCase}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            }
                            {previousItem.defaultQuantity != item.defaultQuantity &&
                                <div>
                                    <div className="u-separator--preview">
                                        <div className="row">
                                            <div className="col col-sml-12 col-lrg-4">
                                                <div className="form__group__label is-preview">Default Quantity</div>
                                            </div>
                                            <div className="col col-sml-12 col-lrg-4">
                                                {previousItem.defaultQuantity}
                                            </div>
                                            <div className="col col-sml-12 col-lrg-4">
                                                {item.defaultQuantity}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            }
                            {previousItem.mcrallowable != item.mcrallowable &&
                                <div>
                                    <div className="u-separator--preview">
                                        <div className="row">
                                            <div className="col col-sml-12 col-lrg-4">
                                                <div className="form__group__label is-preview">Medicare Allowable</div>
                                            </div>
                                            <div className="col col-sml-12 col-lrg-4">
                                                {previousItem.mcrallowable}
                                            </div>
                                            <div className="col col-sml-12 col-lrg-4">
                                                {item.mcrallowable}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            }
                            {previousItem.amountOfUnitsToSend != item.amountOfUnitsToSend &&
                                <div>
                                    <div className="u-separator--preview">
                                        <div className="row">
                                            <div className="col col-sml-12 col-lrg-4">
                                                <div className="form__group__label is-preview">Units To Send</div>
                                            </div>
                                            <div className="col col-sml-12 col-lrg-4">
                                                {previousItem.amountOfUnitsToSend}
                                            </div>
                                            <div className="col col-sml-12 col-lrg-4">
                                                {item.amountOfUnitsToSend}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            }
                            {previousItem.calsPerMl != item.calsPerMl &&
                                <div>
                                    <div className="u-separator--preview">
                                        <div className="row">
                                            <div className="col col-sml-12 col-lrg-4">
                                                <div className="form__group__label is-preview">Cals Per Ml</div>
                                            </div>
                                            <div className="col col-sml-12 col-lrg-4">
                                                {previousItem.calsPerMl}
                                            </div>
                                            <div className="col col-sml-12 col-lrg-4">
                                                {item.calsPerMl}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            }
                            {previousItem.caloriesPerContainer != item.caloriesPerContainer &&
                                <div>
                                    <div className="u-separator--preview">
                                        <div className="row">
                                            <div className="col col-sml-12 col-lrg-4">
                                                <div className="form__group__label is-preview">Cals Per Container</div>
                                            </div>
                                            <div className="col col-sml-12 col-lrg-4">
                                                {previousItem.caloriesPerContainer}
                                            </div>
                                            <div className="col col-sml-12 col-lrg-4">
                                                {item.caloriesPerContainer}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            }
                            {previousItem.mlsPerContainer != item.mlsPerContainer &&
                                <div>
                                    <div className="u-separator--preview">
                                        <div className="row">
                                            <div className="col col-sml-12 col-lrg-4">
                                                <div className="form__group__label is-preview">Mls Per Container</div>
                                            </div>
                                            <div className="col col-sml-12 col-lrg-4">
                                                {previousItem.mlsPerContainer}
                                            </div>
                                            <div className="col col-sml-12 col-lrg-4">
                                                {item.mlsPerContainer}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            }
                            {previousItem.containerSize != item.containerSize &&
                                <div>
                                    <div className="u-separator--preview">
                                        <div className="row">
                                            <div className="col col-sml-12 col-lrg-4">
                                                <div className="form__group__label is-preview">Container Size</div>
                                            </div>
                                            <div className="col col-sml-12 col-lrg-4">
                                                {previousItem.containerSize}
                                            </div>
                                            <div className="col col-sml-12 col-lrg-4">
                                                {item.containerSize}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            }
                            {previousItem.itemTypeId != item.itemTypeId &&
                                <div>
                                    <div className="u-separator--preview">
                                        <div className="row">
                                            <div className="col col-sml-12 col-lrg-4">
                                                <div className="form__group__label is-preview">Container Type</div>
                                            </div>
                                            <div className="col col-sml-12 col-lrg-4">
                                                {previousItem.itemType && previousItem.itemType.name}
                                            </div>
                                            <div className="col col-sml-12 col-lrg-4">
                                                {item.itemType && item.itemType.name}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            }
                            {previousItem.innerCannulaId != item.innerCannulaId &&
                                <div>
                                    <div className="u-separator--preview">
                                        <div className="row">
                                            <div className="col col-sml-12 col-lrg-4">
                                                <div className="form__group__label is-preview">Inner Cannula</div>
                                            </div>
                                            <div className="col col-sml-12 col-lrg-4">
                                                {previousItem.innerCannula && previousItem.innerCannula.itemId}
                                            </div>
                                            <div className="col col-sml-12 col-lrg-4">
                                                {item.innerCannula && item.innerCannula.itemId}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            }
                            {previousItem.defaultItemTypeId != item.defaultItemTypeId &&
                                <div>
                                    <div className="u-separator--preview">
                                        <div className="row">
                                            <div className="col col-sml-12 col-lrg-4">
                                                <div className="form__group__label is-preview">Default Item Type</div>
                                            </div>
                                            <div className="col col-sml-12 col-lrg-4">
                                                {previousItem.defaultItemType && previousItem.defaultItemType.name}
                                            </div>
                                            <div className="col col-sml-12 col-lrg-4">
                                                {item.defaultItemType && item.defaultItemType.name}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            }
                            {previousItem.pumpBrandId != item.pumpBrandId &&
                                <div>
                                    <div className="u-separator--preview">
                                        <div className="row">
                                            <div className="col col-sml-12 col-lrg-4">
                                                <div className="form__group__label is-preview">Pump Brand</div>
                                            </div>
                                            <div className="col col-sml-12 col-lrg-4">
                                                {previousItem.pumpBrand && previousItem.pumpBrand.name}
                                            </div>
                                            <div className="col col-sml-12 col-lrg-4">
                                                {item.pumpBrand && item.pumpBrand.name}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            }
                            {previousItem.specialtyTypeId != item.specialtyTypeId &&
                                <div>
                                    <div className="u-separator--preview">
                                        <div className="row">
                                            <div className="col col-sml-12 col-lrg-4">
                                                <div className="form__group__label is-preview">Specialty Type</div>
                                            </div>
                                            <div className="col col-sml-12 col-lrg-4">
                                                {previousItem.specialtyType && previousItem.specialtyType.name}
                                            </div>
                                            <div className="col col-sml-12 col-lrg-4">
                                                {item.specialtyType && item.specialtyType.name}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            }
                            {previousItem.parentProductId != item.parentProductId &&
                                <div>
                                    <div className="u-separator--preview">
                                        <div className="row">
                                            <div className="col col-sml-12 col-lrg-4">
                                                <div className="form__group__label is-preview">Parent Product</div>
                                            </div>
                                            <div className="col col-sml-12 col-lrg-4">
                                                {previousItem.parentProduct && previousItem.parentProduct.itemId}
                                            </div>
                                            <div className="col col-sml-12 col-lrg-4">
                                                {item.parentProduct && item.parentProduct.itemId}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            }
                            {previousItem.billableToMedicare != item.billableToMedicare &&
                                <div>
                                    <div className="u-separator--preview">
                                        <div className="row">
                                            <div className="col col-sml-12 col-lrg-4">
                                                <div className="form__group__label is-preview">Billable To Medicare</div>
                                            </div>
                                            <div className="col col-sml-12 col-lrg-4">
                                                {previousItem.billableToMedicare ? <i className="u-icon u-icon--sml u-icon--active"></i> : <i className="u-icon u-icon--sml u-icon--inactive"></i>}
                                            </div>
                                            <div className="col col-sml-12 col-lrg-4">
                                                {item.billableToMedicare ? <i className="u-icon u-icon--sml u-icon--active"></i> : <i className="u-icon u-icon--sml u-icon--inactive"></i>}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            }
                            {previousItem.isPreferred != item.isPreferred &&
                                <div>
                                    <div className="u-separator--preview">
                                        <div className="row">
                                            <div className="col col-sml-12 col-lrg-4">
                                                <div className="form__group__label is-preview">Is Preferred</div>
                                            </div>
                                            <div className="col col-sml-12 col-lrg-4">
                                                {previousItem.isPreferred ? <i className="u-icon u-icon--sml u-icon--active"></i> : <i className="u-icon u-icon--sml u-icon--inactive"></i>}
                                            </div>
                                            <div className="col col-sml-12 col-lrg-4">
                                                {item.isPreferred ? <i className="u-icon u-icon--sml u-icon--active"></i> : <i className="u-icon u-icon--sml u-icon--inactive"></i>}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            }
                            {previousItem.isActive != item.isActive &&
                                <div>
                                    <div className="u-separator--preview">
                                        <div className="row">
                                            <div className="col col-sml-12 col-lrg-4">
                                                <div className="form__group__label is-preview">Discontinued</div>
                                            </div>
                                            <div className="col col-sml-12 col-lrg-4">
                                                {!previousItem.isActive ? <i className="u-icon u-icon--sml u-icon--active"></i> : <i className="u-icon u-icon--sml u-icon--inactive"></i>}
                                            </div>
                                            <div className="col col-sml-12 col-lrg-4">
                                                {!item.isActive ? <i className="u-icon u-icon--sml u-icon--active"></i> : <i className="u-icon u-icon--sml u-icon--inactive"></i>}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            }
                            {previousItem.notes != item.notes &&
                                <div>
                                    <div className="u-separator--preview">
                                        <div className="row">
                                            <div className="col col-sml-12 col-lrg-4">
                                                <div className="form__group__label is-preview">Notes</div>
                                            </div>
                                            <div className="col col-sml-12 col-lrg-4">
                                                {previousItem.notes}
                                            </div>
                                            <div className="col col-sml-12 col-lrg-4">
                                                {item.notes}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            }
                            {previousItem.dateCreated != item.dateCreated &&
                                <div>
                                    <div className="u-separator--preview">
                                        <div className="row">
                                            <div className="col col-sml-12 col-lrg-4">
                                                <div className="form__group__label is-preview">Date</div>
                                            </div>
                                            <div className="col col-sml-12 col-lrg-4">
                                                <React.Fragment>{previousItem.dateCreated}</React.Fragment>
                                            </div>
                                            <div className="col col-sml-12 col-lrg-4">
                                                <React.Fragment>{item.dateCreated}</React.Fragment>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            }
                        </div>
                    </div>
                </div>
            </div>
            <PageFooter>
                <BaasicButton
                    className='btn btn--base btn--ghost'
                    label='Back'
                    onClick={() => rootStore.routerStore.goBack()}
                />
            </PageFooter>
        </PreviewLayout>
    )
}

ProductHistoryPreviewTemplate.propTypes = {
    productHistoryPreviewViewStore: PropTypes.object,
    t: PropTypes.func
};

export default defaultTemplate(ProductHistoryPreviewTemplate);
